
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * Export `FormDataProps` type.
 */

export type FormDataProps = {
  company?: string | null,
  countryAlpha2: string,
  dateTime?: string | null,
  districtId?: string | null,
  observations?: string | null,
  place?: string | null,
  productId: string,
  recaptchaToken: string,
  showroomId?: string | null,
  subject: string
};

/**
 * `Query` type.
 */

type Query = {
  formData: FormDataProps,
  locale: string
};

/**
 * Export `submitProductContactForm`.
 */

export async function submitProductContactForm({ formData, locale }: Query) {
  const endpoint = getApiEndpoint('contactUsForm');

  try {
    const { data } = await request.post(endpoint, formData, {
      headers: acceptLanguageHeader(locale)
    });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
